import { Action } from '@ngrx/store';
import { AccountType } from 'src/app/models/account';
import { ITransactionSearchParam, ITransactionSearchResult, ITransactionActionType, ITransactionTypeParam } from 'src/app/models/transactions';

export enum TransactionsActionTypes {
    GET_REVENUE_TRANSACTIONS = 'GET_REVENUE_TRANSACTIONS',
    GET_CASH_TRANSACTIONS = 'GET_CASH_TRANSACTIONS',
    GET_SECURITY_TRANSACTIONS = 'GET_SECURITY_TRANSACTIONS',

    GET_CASH_TRANSACTIONS_SUCCESS = 'GET_CASH_TRANSACTIONS_SUCCESS',
    GET_SECURITY_TRANSACTIONS_SUCCESS = 'GET_SECURITY_TRANSACTIONS_SUCCESS',
    GET_REVENUE_TRANSACTIONS_SUCCESS = 'GET_REVENUE_TRANSACTIONS_SUCCESS',

    RESET_CASH_TRANSACTIONS = 'RESET_CASH_TRANSACTIONS',
    RESET_SECURITY_TRANSACTIONS = 'RESET_SECURITIY_TRANSACTIONS',
    RESET_REVENUE_TRANSACTIONS = 'RESET_REVENUE_TRANSACTIONS',

    GET_REVENUE_TRANSACTIONS_ERROR = 'GET_REVENUE_TRANSACTIONS_ERROR',
    GET_CASH_TRANSACTIONS_ERROR = 'GET_CASH_TRANSACTIONS_ERROR',
    GET_SECURITY_TRANSACTIONS_ERROR = 'GET_SECURITY_TRANSACTIONS_ERROR',

    SELECT_TRANSACTION_TYPE = 'SELECT_TRANSACTION_TYPE',
    SET_ACCOUNT_TYPE = "SET_ACCOUNT_TYPE",

    SELECT_CASH_TRANSACTION_TYPE = "SELECT_CASH_TRANSACTION_TYPE",
    SELECT_REVENUE_TRANSACTION_TYPE = "SELECT_REVENUE_TRANSACTION_TYPE",
    SELECT_SECURITY_TRANSACTION_TYPE = "SELECT_SECURITY_TRANSACTION_TYPE"
}

abstract class GetTransactions implements Action {
    abstract readonly type: string;
    constructor(public payload: ITransactionSearchParam){
    }
}

export class GetCashTransactions extends GetTransactions {
    readonly type = TransactionsActionTypes.GET_CASH_TRANSACTIONS;
    constructor(public payload: ITransactionSearchParam) {
        super(payload);
    }
}

export class GetSecurityTransactions extends GetTransactions {
    readonly type = TransactionsActionTypes.GET_SECURITY_TRANSACTIONS;
    constructor(public payload: ITransactionSearchParam){
        super(payload)
    }
}

export class GetRevenueTransactions extends GetTransactions {
    readonly type = TransactionsActionTypes.GET_REVENUE_TRANSACTIONS;
    constructor(public payload: ITransactionSearchParam) {
        super(payload);
    }
}

export class GetCashTransactionsSuccess implements Action {
    readonly type = TransactionsActionTypes.GET_CASH_TRANSACTIONS_SUCCESS;
    constructor(public payload: ITransactionSearchResult) { }
}

export class GetSecurityTransactionsSuccess implements Action {
    readonly type = TransactionsActionTypes.GET_SECURITY_TRANSACTIONS_SUCCESS;
    constructor(public payload: ITransactionSearchResult) { }
}

export class GetRevenueTransactionsSuccess implements Action {
    readonly type = TransactionsActionTypes.GET_REVENUE_TRANSACTIONS_SUCCESS;
    constructor(public payload: ITransactionSearchResult){}
}

export class RevenueTransactionsDataError implements Action {
    readonly type = TransactionsActionTypes.GET_REVENUE_TRANSACTIONS_ERROR;
    constructor(public payload: string) { }
}

export class CashTransactionsDataError implements Action {
    readonly type = TransactionsActionTypes.GET_CASH_TRANSACTIONS_ERROR;
    constructor(public payload: string) { }
}

export class SecurityTransactionsDataError implements Action {
    readonly type = TransactionsActionTypes.GET_SECURITY_TRANSACTIONS_ERROR;
    constructor(public payload: string) { }
}

export class ResetCashTransactions implements Action {
    readonly type = TransactionsActionTypes.RESET_CASH_TRANSACTIONS;
}

export class ResetSecuritiesTransactions implements Action {
    readonly type = TransactionsActionTypes.RESET_SECURITY_TRANSACTIONS;
}

export class ResetRevenueTransactions implements Action {
    readonly type = TransactionsActionTypes.RESET_REVENUE_TRANSACTIONS;
}

export class SelectTransactionType implements Action {
    readonly type = TransactionsActionTypes.SELECT_TRANSACTION_TYPE;
    constructor(public payload: ITransactionActionType){
    }
}

export class SelectCashTransactionType implements Action {
    readonly type = TransactionsActionTypes.SELECT_CASH_TRANSACTION_TYPE;
    constructor(public payload: ITransactionActionType) {
    }
}

export class SelectRevenueTransactionType implements Action {
    readonly type = TransactionsActionTypes.SELECT_REVENUE_TRANSACTION_TYPE;
    constructor(public payload: ITransactionActionType) {
    }
}

export class SelectSecurityTransactionType implements Action {
    readonly type = TransactionsActionTypes.SELECT_SECURITY_TRANSACTION_TYPE;
    constructor(public payload: ITransactionActionType) {
    }
}

export class SetAccountType implements Action {
    readonly type = TransactionsActionTypes.SET_ACCOUNT_TYPE;
    constructor(public payload: AccountType) {
    }
}


export type TransactionsTypesActions = SelectTransactionType | SetAccountType | SelectCashTransactionType | SelectSecurityTransactionType | SelectRevenueTransactionType ;

export type CashTransactionsActions = GetCashTransactions | ResetCashTransactions | GetCashTransactionsSuccess | CashTransactionsDataError  ;

export type SecurityTransactionsActions = GetSecurityTransactions | GetSecurityTransactionsSuccess | ResetSecuritiesTransactions | SecurityTransactionsDataError  ;

export type RevenueTransactionsActions = GetRevenueTransactions | GetRevenueTransactionsSuccess | ResetRevenueTransactions | RevenueTransactionsDataError ;
